import { HttpStatusKind } from '../interfaces/HttpStatusKind'

export const getKindFromHttpStatusCode = (statusCode: number): HttpStatusKind => {
  if (statusCode >= 100 && statusCode <= 199) { return HttpStatusKind.INFORMATIONAL }
  if (statusCode >= 200 && statusCode <= 299) { return HttpStatusKind.SUCCESSFUL }
  if (statusCode >= 300 && statusCode <= 399) { return HttpStatusKind.REDIRECTION }
  if (statusCode >= 400 && statusCode <= 499) { return HttpStatusKind.CLIENT_ERROR }
  if (statusCode >= 500 && statusCode <= 599) { return HttpStatusKind.SERVER_ERROR }
  return HttpStatusKind.UNKNOWN
}
